module.exports = __webpack_public_path__ + "img/2.8b6a0292.jpg";